var map = {
	"./081.png": "ecae",
	"./BAAC.png": "1cfb",
	"./BAY.png": "0d98",
	"./BBL.png": "a6fb",
	"./BNP.png": "b0ee",
	"./BOA.png": "8d22",
	"./CACIB.png": "1501",
	"./CIMB.png": "d2aa",
	"./CITI.png": "1a7e",
	"./DB.png": "7989",
	"./GHB.png": "a3bb",
	"./GSB.png": "b14b",
	"./HSBC.png": "683d",
	"./IBANK.png": "b1c0",
	"./ICBC.png": "c0d0",
	"./JPM.png": "ce71",
	"./KBANK.png": "952f",
	"./KK.png": "18fb",
	"./KKP.png": "9f26b",
	"./KTB.png": "27a0",
	"./LHB.png": "410b",
	"./MB.png": "c3b6",
	"./MEGA.png": "8e94",
	"./MUFG.png": "2df8",
	"./RBS.png": "1bc6",
	"./SC.png": "eccd",
	"./SCB.png": "8066",
	"./SMBC.png": "7454",
	"./TBANK.png": "a7c4",
	"./TCRB.png": "3c7f",
	"./TISCO.png": "2d72",
	"./TMB.png": "3266",
	"./TMBTHANACHART.png": "23c5",
	"./TRUEWALLET.png": "f14c",
	"./TTB.png": "093b",
	"./UOB.png": "8c41",
	"./cloudpay.png": "01e0",
	"./true-wallet.png": "3d13"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4e21";